import { Typography, Link } from "@mui/material";
import React from "react";
import "./TransferWorks.css";
import Card from "./Card.jsx";
import { workData } from "../content.js";
import CheckEligibilityBanner from "../../CheckEligibilityBanner/CheckEligibilityBanner.jsx";
// import { workData } from "../content.js";
const TransfersWork = () => {
  return (
    <>
      <div className="details_container">
        <section className="pt-5  d-flex flex-column gap-3">
          <Typography
            variant="h5"
            style={{
              fontFamily: "'Archivo', sans-serif",
              fontWeight: 700,
              color: "#1F1F1F",
            }}
          >
            {workData[0].heading}
          </Typography>
          <div>
            <Typography
              sx={{
                fontFamily: "'Archivo', sans-serif",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "normal",
                textAlign: "start",
                color: "#1F1F1F",
              }}
            >
              {workData[0].headDescription}
            </Typography>
            {/* list data */}
            <div id="personal_loan" className="mt-2">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                  fontWeight: 600,
                }}
              >
                1.{workData[0].subheadOne}
              </Typography>
              <ul
                style={{
                  listStyle: "disc",
                  fontSize: 16,
                  color: "#1f1f1f",
                  lineHeight: "24px",
                }}
                className=" archivo mt-3"
              >
                {workData[0].subheadOneList &&
                  workData[0].subheadOneList.map((item, index) => (
                    <li key={index}>
                      <strong>{item.heading}</strong>
                      {item.description}
                    </li>
                  ))}
              </ul>
            </div>
            <div id="transfer_products" className="mt-2">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                  fontWeight: 600,
                }}
              >
                2.{workData[0].subheadTwo}
              </Typography>
              <ul
                style={{
                  listStyle: "disc",
                  fontSize: 16,
                  color: "#1f1f1f",
                  lineHeight: "24px",
                }}
                className=" archivo mt-3"
              >
                {workData[0].subheadTwoList &&
                  workData[0].subheadTwoList.map((item, index) => (
                    <li key={index}>
                      <strong>{item.heading}</strong>
                      {item.description}
                    </li>
                  ))}
              </ul>
            </div>
            <div id="emi_conversion" className="mt-2">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                  fontWeight: 600,
                }}
              >
                3.{workData[0].subheadThree}
              </Typography>
              <ul
                style={{
                  listStyle: "disc",
                  fontSize: 16,
                  color: "#1f1f1f",
                  lineHeight: "24px",
                }}
                className=" archivo mt-3"
              >
                {workData[0].subheadThreeList &&
                  workData[0].subheadThreeList.map((item, index) => (
                    <li key={index}>
                      <strong>{item.heading}</strong>
                      {item.description}
                    </li>
                  ))}
              </ul>
            </div>
            <div id="personal_loan" className="mt-2">
              <Typography
                sx={{
                  fontFamily: "'Archivo', sans-serif",
                  fontSize: "18px",
                  lineHeight: "24px",
                  letterSpacing: "normal",
                  textAlign: "start",
                  color: "#1F1F1F",
                  fontWeight: 600,
                }}
              >
                {workData[0].headingTwo}
              </Typography>
              <ul
                style={{
                  listStyle: "disc",
                  fontSize: 16,
                  color: "#1f1f1f",
                  lineHeight: "24px",
                }}
                className=" archivo mt-3"
              >
                {workData[0].infoList &&
                  workData[0].infoList.map((item, index) => (
                    <li key={index}>
                      <strong>{item.heading}</strong>
                      {item.description}
                    </li>
                  ))}
              </ul>
            </div>
            <Typography
              sx={{
                fontFamily: "'Archivo', sans-serif",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "normal",
                textAlign: "start",
                color: "#1F1F1F",
              }}
            >
              {workData[0].paraOne}
            </Typography>
            <p className="more_content font_size">
              <span className="fw-bold">
                » MORE:{" "}
                <Link
                  href={"/what-is-balance-transfer"}
                  underline="hover"
                  sx={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: 400,
                    cursor: "pointer",
                    letterSpacing: "0.48px",
                  }}
                >
                  {" "}
                  What is a balance transfer, and should I do one?
                </Link>
              </span>
            </p>
          </div>
        </section>

        <CheckEligibilityBanner />
      </div>
    </>
  );
};

export default TransfersWork;
